import { unref as E } from "vue";
const A = "https://www.youtube-nocookie.com", T = "https://www.youtube.com", R = "vue-youtube";
var N = /* @__PURE__ */ ((O) => (O[O.INVALID_PARAMETER = 2] = "INVALID_PARAMETER", O[O.HTML5_ERROR = 5] = "HTML5_ERROR", O[O.NOT_FOUND = 100] = "NOT_FOUND", O[O.NOT_ALLOWED = 101] = "NOT_ALLOWED", O[O.NOT_ALLOWED_DISGUISE = 150] = "NOT_ALLOWED_DISGUISE", O))(N || {}), _ = /* @__PURE__ */ ((O) => (O[O.UNSTARTED = -1] = "UNSTARTED", O[O.ENDED = 0] = "ENDED", O[O.PLAYING = 1] = "PLAYING", O[O.PAUSED = 2] = "PAUSED", O[O.BUFFERING = 3] = "BUFFERING", O[O.VIDEO_CUED = 5] = "VIDEO_CUED", O))(_ || {});
function L(O) {
  const D = E(O);
  return (D == null ? void 0 : D.$el) ?? D;
}
export {
  T as HOST_COOKIE,
  A as HOST_NO_COOKIE,
  R as PROVIDE_KEY,
  N as PlayerError,
  _ as PlayerState,
  L as unrefElement
};
